<template>
  <div class="question-paper-catagory">
    <div class="content">
      <TreeGrid :rows="list" :columns="columns" :max-level="2">
        <template slot-scope="{row}" slot="c1">
          <span v-if="row.parent_id==0" class="chapter-title">  第{{row._index+1}}章 {{row.title}}</span>
          <span v-else>第{{row._index+1}}节 {{row.title}}</span>
          <span v-if="row.children && row.children.length">（含{{row.children.length}}个课时）</span>
        </template>
        <template slot-scope="{row}" slot="action">
          <Button
            type="text"
            size="small"
            @click="onAddPeriod(row)" v-show="!row.parent_id">新增节</Button>
          <span v-show="!row.parent_id">-</span>
          <Button v-show="row.parent_id" type="text" size="small" @click="onShowPaper(row)">查看</Button>
          <span v-show="row.parent_id">-</span>
          <Button v-show="row.parent_id" type="text" size="small" @click="onShowLearner(row)">学员列表</Button>
          <span v-show="row.parent_id">-</span>

          <Button v-if="row.parent_id" type="text" size="small" @click="onEditPeriod(row)">编辑</Button>
          <Button v-else type="text" size="small" @click="onEdit(row)">编辑</Button>

          <span>-</span>
          <Button type="text" size="small" @click="onDelete(row)">删除</Button>
        </template>
      </TreeGrid>
        <div style="text-align:center;margin:20px">
          <Button type="primary" @click="onAdd(null)">新增章节</Button>
        </div>
    </div>
    <Modal v-model="modal.show" :title="modal.title">
      <div>
        <Form ref="modalForm" :model="modal.form" :rules="modal.formRules" :label-width="90">
          <FormItem label="章节名称" prop="name">
            <Input
              v-model="modal.form.title"
              placeholder="章节名称最多输入15个字"
              :maxlength="15"
              style="width:300px;"
            ></Input>
          </FormItem>
          <FormItem label="排序" prop="sort">
            <Input
              v-model="modal.form.sort"
              placeholder="请输入整数"
              style="width:300px;"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="modal.show = false">取消</Button>
        <Button type="primary" @click="onModalOk" :loading="modal.btnLoading">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "QuestionExerciseChapter",
  data() {
    return {
      searchCondition: {
        name: "",
        init() {
          this.name = "";
        }
      },
      list: [],
      columns: [
        { title: "章节名称", slot: "c1" },
        { title: "排序", key: "sort", align: "center" },
        { title: "操作", slot: "action", width: 240, align: "center" }
      ],
      modal: {
        show: false,
        title: "",
        type: "",
        form: {
          title: "",
          sort: 0
        },
        formRules: {
          title: [
            { required: true, message: "分类名称不能为空", trigger: "blur" }
          ],
          sort: [
            { required: true, message: "分类排序不能为空" }
          ]
        },
        parentName: "",
        parentID: 0,
        selfID: 0,
        btnLoading: false
      },
      exercise_id: this.$route.query.exercise_id
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    onShowLearner(row) {
      this.$router.push({
        name: "ExamDetail",
        query: { type: 5, id: row.chapter_exam.id }
      });
    },
    onShowPaper(row) {
      this.$router.push({
        name: "QuestionPaperDetail",
        query: { id: row.chapter_exam.exam_id }
      });
    },
    onAddPeriod(row) {
      this.$router.push({
        name: "QuestionExerciseChapterPeriodCreate",
        query: { chapter_id: row.id }
      });
    },
    onEditPeriod(row) {
      this.$router.push({
        name: "QuestionExerciseChapterPeriodEdit",
        query: { chapter_id: row.parent_id, id:row.id }
      });
    },
    onAdd(row) {
      this.modal.show = true;
      this.modal.title = "新增章节";
      this.modal.type = "add";
      this.modal.form.title = "";
      this.modal.form.sort = 0;
      if (!row) {
        this.modal.parentName = "无";
        this.modal.parentID = 0;
      } else {
        this.modal.parentName = row.name;
        this.modal.parentID = row.id;
      }
    },
    onEdit(row) {
      this.modal.show = true;
      this.modal.title = "编辑章节";
      this.modal.type = "edit";
      this.modal.selfID = row.id;
      this.modal.form.title = row.title;
      this.modal.form.sort = row.sort;
    },
    onDelete(row) {
      if (row.exam_count) {
        this.$Modal.info({
          title: "提示",
          content: "当前分类已被使用，无法删除"
        });
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "确定要删除该章节吗？",
          onOk: () => {
            this.$http.delete(`/api/exam/exercise-chapter/${row.id}`).then(() => {
              this.$Message.success("删除成功");
              this.requestList();
            });
          }
        });
      }
    },
    onModalOk() {
      this.$refs.modalForm.validate(valid => {
        if (!valid) return;
        this.modal.btnLoading = true;
        if (this.modal.type == "add") {
          this.$http
            .post("/api/exam/exercise-chapter", {
              parent_id: this.modal.parentID,
              title: this.modal.form.title,
              sort: this.modal.form.sort,
              exercise_id: this.exercise_id
            })
            .then(() => {
              this.modal.btnLoading = false;
              this.modal.show = false;
              this.$Message.success("添加成功");
              this.requestList();
            });
        } else {
          this.$http
            .put(`/api/exam/exercise-chapter/${this.modal.selfID}`, {
              title: this.modal.form.title,
              exercise_id: this.exercise_id,
              sort: this.modal.form.sort,
            })
            .then(() => {
              this.modal.btnLoading = false;
              this.modal.show = false;
              this.$Message.success("编辑成功");
              this.requestList();
            });
        }
      });
    },
    // other
    getParentName(parentID) {
      for (const i of this.list) {
        if (parentID == i.id) {
          return i.name;
        }
      }
      return "无";
    },
    // request
    requestList() {
      this.$http.get("/api/exam/exercise-chapter",{exercise_id:this.exercise_id}).then(data => {
        this.list = data.list;
        this.list.forEach(i => {
          if (!i.children || !i.children.length) {
            i._disableExpand = true;
          }
        });
      });
    }
  }
};
</script>
<style>
.chapter-title{
  font-weight: bold;
}
</style>
